var pop = {
  init: function () {
    var s = this;
    var btn_el = $('.pop_btn');
    $(window).off('click.pop');
    $('input').off('focus.pop');

    btn_el.each(function () {
      var th = $(this);
      var pop_el = $(th.data('targetpop'));

      th.off('click.pop').on("click.pop",function(e) {
        e.preventDefault();
        $('.pop.popshow').not(pop_el).removeClass('popshow');
        $('.pop_btn.active').not(th).removeClass('active');
		    pop_el.toggleClass("popshow");
        th.toggleClass("active");

        if (pop_el.hasClass('popshow')) {
          $(window).off('click.pop').on('click.pop', function (e) {
            if (!$(e.target).closest('.pop').length && !$(e.target).closest('.pop_btn').length) {
              s.close();
            }
          });
          
          $('input').on('focus.pop', function () {
            s.close();
          });
        } else {
          $(window).off('click.pop');
          $('input').off('focus.pop');
        }
      });
    });

    if (isMobile && $('.mobile_tooltip').length) pop.mobileTooltip();
  },


  mobileTooltip: function () {
    var tooltip_el = $('.mobile_tooltip');
    $(window).off('click.pop');
    
    tooltip_el.each(function () {
      var th = $(this);
      var btn = th.find('.mobile_btn');

      th.children('a').addClass('no-hover');

      btn.click(function () {
        // e.preventDefault();
        $('.mobile_tooltip.active').not(th).removeClass('active');
        th.toggleClass('active');

        if (th.hasClass('active')) {
          $(window).off('click.tooltip').on('click.tooltip', function (e) {
            if ( !$(e.target).closest('.mobile_tooltip').length ) {
              $('.mobile_tooltip.active').removeClass('active');
            }
          });
        } else {
          $(window).off('click.pop');
        }
      });
    })
  },

  close: function () {
    $('.pop').removeClass('popshow');
    $('.pop_btn').removeClass('active');
    $('.mobile_tooltip').removeClass('active');
  }
}

// $(function () {
//   pop.init();
// });
